<div *ngIf="cargando">
  <div class="text-center py-5">
    <mat-spinner class="img-center"></mat-spinner>
  </div>
  <div class="text-center py-5">
    <span>Cargando datos...</span>
  </div>
</div>

<div *ngIf="!cargando">
  <!-- ====================== select cuando se modifica un empleado ====================== -->
  <ng-container *ngIf="asignandoHorario">
    <div class="m-3 opacity-50 text-center">
      <h4 class="mb-0">Asignando horario a {{ nombreCompleto() }}</h4>
    </div>

    <div class="d-flex justify-content-end align-items-end mx-3">
      <button class="text-danger mx-2" mat-raised-button (click)="horarioSeleccionado = undefined; asignandoHorario = false">Cancelar asignación</button>
      <button class="text-success" mat-raised-button (click)="guardarAsignacionHorario()">Guardar asignación</button>
    </div>
    <div class="row g-3 text-start mx-2" [ngClass]="{'mh-5': !horarioSeleccionado}">
      <div class="col-6">
        <label class="mb-0">Selecciona el horario</label>
        <ng-select [(ngModel)]="horarioSeleccionado" [items]="horarios" bindLabel="nombreHorario" notFoundText="Horario no encontrado" placeholder="Selecciona el horario" appendTo="body" dropdownPosition="auto"> </ng-select>
      </div>
      <div class="col-6">
        <label class="form-label mb-0">Fecha de asignación</label>
        <input type="date" [min]="minDate.toISOString().split('T')[0]" [(ngModel)]="fechaAsignacion" class="form-control">
      </div>
    </div>

    <div class="col-12" *ngIf="!!horarioSeleccionado" >
      <app-horario-detalle [horario]="horarioSeleccionado" [soloConsulta]="true" [horarioEmpleado]="true"></app-horario-detalle>
    </div>
  </ng-container>

  <!-- ====================== horarios asignados al empleado ====================== -->
  <div class="px-3 mt-4" *ngIf="!asignandoHorario">
    <div class="m-3 opacity-50 col-12" *ngIf="horariosEmpleado.length > 0">
      <h4 class="mb-0">{{ nombreCompleto() }} tiene {{ horariosEmpleado.length }} horarios signados</h4>
    </div>

    <div class="d-flex justify-content-end px-3 mt-2">
      <button mat-raised-button matTooltip="Nuevo horario" class="ms-3 text-success" (click)="asignandoHorario = true">
        <mat-icon class="me-0">more_time</mat-icon>
        <p class="ms-2 mb-0">Asignar horario</p>
      </button>
      <button mat-raised-button matTooltip="Nuevo horario" class="ms-3 text-primary" (click)="agregarHorarioDialog()">
        <mat-icon class="me-0">more_time</mat-icon>
        <p class="ms-2 mb-0">Nuevo horario</p>
      </button>
    </div>

    <div class="alert alert-primary mt-4" *ngIf="!cargando && horariosEmpleado.length <= 0">
      <div>
        <strong>El empleado no tiene horario asignado</strong>
        <p>Aún no se ha asignado ningún horario al empleado {{ nombreCompleto() }}</p>
      </div>
    </div>

    <div class="col-12">
      <div *ngFor="let horario of horariosEmpleado">
        <app-horario-detalle [horario]="horario" [soloConsulta]="false" [horarioEmpleado]="true"></app-horario-detalle>
      </div>
    </div>
  </div>
</div>
